<div class="scanner-page" [class.scanner-page--stocktaking]="isStocktakingDocMode">
  <mat-card class="scanner-shell">
    <div class="shell-top" *ngIf="!isStocktakingDocMode && !isMobileLayout">
      <div class="shell-top-desktop">
        <app-warehouse-selector [control]="warehouseControl"></app-warehouse-selector>

        <mat-button-toggle-group class="mode-switch mode-switch--desktop" [attr.data-mode]="mode" [formControl]="modeControl">
          <mat-button-toggle value="PLACE">Разместить</mat-button-toggle>
          <mat-button-toggle value="PICK">Снять</mat-button-toggle>
          <mat-button-toggle value="INFO">Инфо</mat-button-toggle>
          <mat-button-toggle value="COUNT" *ngIf="canUseAdhocCount">Переучет</mat-button-toggle>
        </mat-button-toggle-group>

        <a
          mat-stroked-button
          routerLink="/docs/moving/scan"
          class="moving-tsd-entry moving-tsd-entry--desktop"
          title="Создать передвижение"
        >
          <mat-icon>swap_horiz</mat-icon>
          Передвижение
        </a>
      </div>
    </div>

    <div class="doc-shell-top" *ngIf="isStocktakingDocMode">
      <div class="doc-shell-heading">
        <span class="doc-shell-badge"><mat-icon>qr_code_scanner</mat-icon> Переучёт №{{ stocktakingDoc?.id }}</span>
        <a *ngIf="stocktakingDoc?.id" mat-stroked-button [routerLink]="['/docs/stocktaking-v2/update', stocktakingDoc?.id]">
          <mat-icon>arrow_back</mat-icon> К документу
        </a>
      </div>
      <div class="doc-shell-meta">
        <strong>{{ stocktakingDoc?.warehouse?.description }}</strong>
        <span>{{ stocktakingStatusLabel }}</span>
      </div>
      <div class="doc-shell-warning" *ngIf="labelPrinterWarning">
        <span>{{ labelPrinterWarning }}</span>
        <a routerLink="/warehouse/printers">Настройки принтеров</a>
      </div>
    </div>

    <div class="closed-doc-note" *ngIf="isMobileLayout && isReadOnlyStocktakingDoc">
      Подсчёт закрыт. Откройте документ, чтобы посмотреть результат во вкладке «Отчёт».
    </div>
    <ng-template #captureZoneTemplate>
      <div *ngIf="!isReadOnlyStocktakingDoc" class="scan-zone" (click)="focusCaptureInput(true)">
        <div class="scan-zone-head">
          <div class="scan-zone-label">Сканер</div>
          <div class="scan-zone-head-actions">
            <button
              mat-button
              type="button"
              class="scan-zone-keyboard"
              [class.scan-zone-keyboard--active]="captureKeyboardEnabled"
              (click)="toggleCaptureKeyboard($event)"
            >
              {{ captureKeyboardEnabled ? 'Сканер' : 'Клавиатура' }}
            </button>
            <div class="scan-zone-mode">
              {{ mode === 'INFO' || currentCell ? 'Товар / ID' : 'Код полки' }}
            </div>
          </div>
        </div>
        <div class="capture-field">
          <input
            #captureInput
            class="capture-input"
            type="text"
            [formControl]="captureControl"
            [placeholder]="captureHint"
            autocomplete="off"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            [attr.inputmode]="captureKeyboardEnabled ? 'text' : 'none'"
            enterkeyhint="done"
            (keydown)="onCaptureKeydown($event)"
          />
        </div>
        <div class="scan-zone-hint" *ngIf="mode === 'INFO' || !currentCell || pendingUnknownBarcode">
          {{ captureExample }}
          <span *ngIf="!captureKeyboardEnabled"> · Для ручного ввода включите клавиатуру</span>
        </div>
      </div>
    </ng-template>

    <section class="stage-card" [attr.data-mode]="mode">
      <div class="stage-mobile-inline" *ngIf="isMobileLayout">
        <span class="stage-badge">{{ modeTitle }}</span>
        <span class="stage-mobile-cell" [class.stage-mobile-cell--inactive]="isStageStatusInactive">
          {{ currentStageStatusLabel }}
        </span>
      </div>

      <div class="stage-topline">
        <div class="stage-badge">{{ modeTitle }}</div>
        <div class="stage-status" [class.stage-status--inactive]="isStageStatusInactive">
          {{ currentStageStatusLabel }}
        </div>
      </div>

      <div class="stage-main">
        <div class="stage-title" *ngIf="pendingCellSwitch || pendingUnknownBarcode || isReadOnlyStocktakingDoc; else compactStageTitle">
          {{ currentInstruction }}
        </div>
        <ng-template #compactStageTitle>
          <div class="stage-title" *ngIf="!warehouse?.id">Выберите склад</div>
          <div class="stage-title" *ngIf="warehouse?.id && mode === 'INFO' && !currentProduct">Сканируйте товар</div>
          <div class="stage-title" *ngIf="warehouse?.id && mode === 'INFO' && currentProduct">Информация о товаре</div>
          <div class="stage-title" *ngIf="warehouse?.id && mode !== 'INFO' && !currentCell">Сканируйте полку</div>
          <div class="stage-title" *ngIf="currentCell && pendingProduct">Товар готов</div>
          <div class="stage-title" *ngIf="currentCell && !pendingProduct && mode !== 'INFO'">Сканируйте товар</div>
        </ng-template>

        <div class="stage-subtitle" *ngIf="warehouse?.id && !isReadOnlyStocktakingDoc">
          <ng-container *ngIf="mode === 'INFO'">Просмотр информации по складу {{ warehouse?.description }}</ng-container>
          <ng-container *ngIf="mode !== 'INFO' && !currentCell">Сначала нужен код ячейки</ng-container>
          <ng-container *ngIf="currentCell && mode === 'PLACE'">Размещение на полку {{ currentCell.code }}</ng-container>
          <ng-container *ngIf="currentCell && mode === 'PICK'">Снятие с полки {{ currentCell.code }}</ng-container>
          <ng-container *ngIf="currentCell && mode === 'COUNT'">Пересчет полки {{ currentCell.code }}</ng-container>
        </div>
      </div>

      <div
        class="stage-summary"
        *ngIf="!isMobileLayout && (isStocktakingDocMode || pendingProduct || currentProduct || currentProductHintLabel)"
      >
        <div class="summary-row" *ngIf="isStocktakingDocMode">
          <span>Документ</span>
          <strong>#{{ stocktakingDoc?.id }}</strong>
        </div>
        <div class="summary-row" *ngIf="pendingProduct">
          <span>Товар</span>
          <strong>{{ pendingProductLabel }}</strong>
        </div>
        <div class="summary-row" *ngIf="currentProduct && !pendingProduct">
          <span>Последний</span>
          <strong>{{ compactProductLabel }}</strong>
        </div>
        <div class="summary-row" *ngIf="currentProductHintLabel">
          <span>Подсказки</span>
          <strong>{{ currentProductHintLabel }}</strong>
        </div>
      </div>

      <ng-container *ngIf="!isMobileLayout" [ngTemplateOutlet]="captureZoneTemplate"></ng-container>

      <div
        class="secondary-actions secondary-actions--compact"
        *ngIf="!isMobileLayout && ((mode !== 'COUNT' && warehouse?.id) || currentProduct || (mode !== 'INFO' && currentCell))"
      >
        <button
          *ngIf="warehouse?.id && (mode !== 'COUNT' || isStocktakingDocMode)"
          mat-stroked-button
          class="quick-action"
          type="button"
          (click)="openManualProductSearch($event)"
        >
          Найти товар
        </button>
        <button
          mat-stroked-button
          class="quick-action"
          type="button"
          (click)="onProductLabelButtonClick($event)"
          (contextmenu)="onProductLabelButtonContextMenu($event)"
          (touchstart)="onProductLabelButtonTouchStart()"
          (touchend)="onProductLabelButtonTouchEnd()"
          (touchcancel)="onProductLabelButtonTouchEnd()"
          [disabled]="!currentProduct"
        >
          Этикетка товара
        </button>
        <button
          *ngIf="mode !== 'INFO'"
          mat-stroked-button
          class="quick-action"
          type="button"
          (click)="onCellLabelButtonClick($event)"
          (contextmenu)="onCellLabelButtonContextMenu($event)"
          (touchstart)="onCellLabelButtonTouchStart()"
          (touchend)="onCellLabelButtonTouchEnd()"
          (touchcancel)="onCellLabelButtonTouchEnd()"
          [disabled]="!currentCell"
        >
          Этикетка ячейки
        </button>
      </div>

      <div
        class="secondary-actions secondary-actions--compact"
        *ngIf="!isMobileLayout && mode !== 'COUNT' && mode !== 'INFO' && (currentCell || activeQtyOverride > 1)"
      >
        <button
          *ngIf="currentCell"
          mat-stroked-button
          class="quick-action"
          type="button"
          (click)="toggleQtyOverridePanel()"
        >
          {{ activeQtyOverride > 1 ? ('Кол-во: ' + activeQtyOverride) : 'Количество' }}
        </button>
        <button
          *ngIf="activeQtyOverride > 1"
          mat-button
          class="quick-action quick-action--ghost"
          type="button"
          (click)="resetQtyOverride()"
        >
          Сброс
        </button>
      </div>

      <div *ngIf="!isMobileLayout && showQtyOverride && mode !== 'COUNT' && mode !== 'INFO'" class="qty-panel">
        <div class="qty-inline-row">
          <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(-2)">-2</button>
          <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(-1)">-1</button>
          <label class="qty-inline-field" aria-label="Количество">
            <input
              class="qty-inline-input"
              type="number"
              step="0.01"
              [formControl]="qtyControl"
              placeholder="Кол-во"
              (keyup.enter)="applyCustomQtyOverride()"
            />
          </label>
          <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(1)">+1</button>
          <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(2)">+2</button>
        </div>
        <div class="qty-apply-row">
          <button mat-flat-button color="primary" type="button" class="qty-apply-button" (click)="applyCustomQtyOverride()">
            Применить
          </button>
        </div>
      </div>

      <div class="series-banner" *ngIf="!isMobileLayout && scanSeries">
        <div class="section-label">Последнее сканирование</div>
        <div class="series-main">{{ scanSeries.productLabel }}</div>
        <div class="series-sub">
          {{ scanSeries.cellCode }} · {{ scanSeries.qty }} шт.
        </div>
      </div>
    </section>

    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  </mat-card>

  <mat-card *ngIf="!isMobileLayout && mode === 'COUNT' && canUseAdhocCount" class="count-session-card">
    <div class="card-header">
      <div>
        <h3>{{ isReadOnlyStocktakingDoc ? 'Подсчёт закрыт' : isStocktakingDocMode ? 'Сдача полки в документ' : 'Переучет полки' }}</h3>
        <p *ngIf="currentCell">Считается только полка {{ currentCell.code }}</p>
        <p *ngIf="!currentCell && !isReadOnlyStocktakingDoc">Сначала сканируйте полку</p>
      </div>
      <div class="count-actions" *ngIf="!isReadOnlyStocktakingDoc">
        <button
          mat-flat-button
          color="primary"
          type="button"
          [disabled]="!canFinishCountSession"
          (click)="finishCountSession()"
        >
          {{ countSessionItems.length ? 'Завершить полку' : 'Сохранить пустую полку' }}
        </button>
        <button
          mat-button
          type="button"
          [disabled]="loading || !currentCell"
          (click)="discardCountSession()"
        >
          Сбросить
        </button>
      </div>
    </div>

    <div *ngIf="countSessionItems.length; else countEmptyState" class="count-list">
      <div class="count-row" *ngFor="let item of countSessionItems; trackBy: trackByCountItem">
        <div class="count-product">
          <div class="count-title">{{ item.product.brand.description }} {{ item.product.article }}</div>
          <div class="count-description">{{ item.product.description }}</div>
          <div class="count-submeta" *ngIf="isStocktakingDocMode">
            <ng-container *ngIf="currentProduct?.id === item.product.id">Система: {{ getExpectedShelfQtyForProduct(item.product.id) | number:'1.0-2' }} · </ng-container>Факт: {{ item.qty | number:'1.0-2' }}
          </div>
        </div>
        <div class="count-controls">
          <button mat-stroked-button type="button" (click)="adjustCountItem(item, -1)">-1</button>
          <div class="count-qty">{{ item.qty }}</div>
          <button mat-stroked-button type="button" (click)="adjustCountItem(item, 1)">+1</button>
          <button
            mat-button
            type="button"
            *ngIf="countEditingProductId !== item.product.id"
            (click)="startCountItemEdit(item)"
          >
            Изменить
          </button>
        </div>
        <div class="count-edit" *ngIf="countEditingProductId === item.product.id">
          <mat-form-field>
            <mat-label>Количество</mat-label>
            <input
              #countQtyInput
              matInput
              type="number"
              step="0.01"
              [formControl]="countQtyControl"
              (keyup.enter)="applyCountItemEdit(item)"
            />
          </mat-form-field>
          <div class="count-edit-actions">
            <button mat-flat-button color="primary" type="button" (click)="applyCountItemEdit(item)">
              Сохранить
            </button>
            <button mat-button type="button" (click)="cancelCountItemEdit()">Отмена</button>
          </div>
        </div>
      </div>
    </div>

    <ng-template #countEmptyState>
      <div class="empty-state">
        {{ isReadOnlyStocktakingDoc ? 'Результат доступен во вкладке «Отчёт» документа. Сканирование для этого переучёта завершено.' : currentCell ? 'Сканируйте товары, чтобы собрать факт по этой полке.' : 'Сканируйте код полки, затем товары на ней. Здесь появится результат подсчёта.' }}
      </div>
    </ng-template>
  </mat-card>

  <mat-card *ngIf="!isMobileLayout && recentActionFeed.length" class="recent-card">
    <h3>Последнее</h3>
    <div class="recent-list">
      <div class="recent-row" *ngFor="let action of recentActionFeed; trackBy: trackByAction">
        <div class="recent-main">
          <div class="recent-title">{{ action.productLabel }}</div>
          <div class="recent-message">{{ action.message }}</div>
        </div>
        <div class="recent-meta" [class.error]="!action.success">
          {{ action.cellCode }} · {{ action.qty }} шт.
        </div>
      </div>
    </div>
  </mat-card>

  <mat-card *ngIf="!isMobileLayout && currentProduct" class="product-info-card">
    <section class="product-hero product-hero--desktop">
      <div class="product-hero__media">
        <img
          *ngIf="currentProductImageUrl; else desktopCurrentProductFallbackImage"
          [src]="currentProductImageUrl"
          [alt]="currentProductDisplayMeta || currentProductDisplayName || 'Товар'"
        />
        <ng-template #desktopCurrentProductFallbackImage>
          <div class="product-hero__placeholder">
            <mat-icon>inventory_2</mat-icon>
          </div>
        </ng-template>
      </div>

      <div class="product-hero__copy">
        <div class="product-hero__eyebrow">{{ mode === 'INFO' ? 'Информация о товаре' : 'Текущий товар' }}</div>
        <div class="product-hero__meta">{{ currentProductDisplayMeta }}</div>
        <div class="product-hero__title">{{ currentProductDisplayName || 'Без названия' }}</div>
        <div class="product-facts">
          <div class="product-fact" *ngIf="!isStocktakingDocMode || mode !== 'COUNT'">
            <span class="product-fact__label">Закупка</span>
            <strong class="product-fact__value">{{ currentProductPurchasePrice | number:'1.0-2' }}</strong>
          </div>
          <div class="product-fact" *ngIf="!isStocktakingDocMode || mode !== 'COUNT'">
            <span class="product-fact__label">Розница</span>
            <strong class="product-fact__value">{{ currentProductRetailPrice | number:'1.0-2' }}</strong>
          </div>
          <div class="product-fact" *ngIf="mode === 'INFO'">
            <span class="product-fact__label">Склад</span>
            <strong class="product-fact__value">{{ warehouse?.description || 'Не выбран' }}</strong>
          </div>
          <div class="product-fact" *ngIf="mode === 'INFO'">
            <span class="product-fact__label">Остаток</span>
            <strong class="product-fact__value">{{ currentProductTotalQty | number:'1.0-2' }}</strong>
          </div>
          <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
            <span class="product-fact__label">Система на полке</span>
            <strong class="product-fact__value">{{ currentExpectedShelfQty | number:'1.0-2' }}</strong>
          </div>
          <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
            <span class="product-fact__label">Отсканировано</span>
            <strong class="product-fact__value">{{ currentScannedQty | number:'1.0-2' }}</strong>
          </div>
          <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
            <span class="product-fact__label">Разница</span>
            <strong class="product-fact__value">{{ currentCountDeltaLabel }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section
      class="count-focus-card count-focus-card--desktop"
      *ngIf="isStocktakingDocMode && mode === 'COUNT' && currentProduct"
    >
      <div class="count-focus-header">
        <div class="tab-section__title">Факт по текущему товару</div>
        <div class="count-focus-meta">Полка {{ currentCell?.code || 'не выбрана' }}</div>
      </div>

      <div class="count-focus-stats">
        <div class="count-focus-stat">
          <span>Система</span>
          <strong>{{ currentExpectedShelfQty | number:'1.0-2' }}</strong>
        </div>
        <div class="count-focus-stat">
          <span>Факт</span>
          <strong>{{ currentScannedQty | number:'1.0-2' }}</strong>
        </div>
        <div class="count-focus-stat">
          <span>Разница</span>
          <strong>{{ currentCountDeltaLabel }}</strong>
        </div>
      </div>

      <div class="count-focus-actions" *ngIf="(currentCountSessionItem || canAlignCurrentCountToSystem) && !isCurrentCountEditing">
        <button mat-stroked-button type="button" (click)="adjustCurrentCount(-1)">-1</button>
        <button mat-stroked-button type="button" (click)="adjustCurrentCount(1)">+1</button>
        <button
          mat-stroked-button
          type="button"
          *ngIf="canAlignCurrentCountToSystem"
          (click)="alignCurrentCountToSystem()"
        >
          Как в системе
        </button>
        <button mat-button type="button" (click)="startCurrentCountEdit()">Изменить</button>
      </div>

      <div class="count-edit count-edit--current" *ngIf="isCurrentCountEditing">
        <mat-form-field>
          <mat-label>Фактическое количество</mat-label>
          <input
            #countQtyInput
            matInput
            type="number"
            step="0.01"
            [formControl]="countQtyControl"
            (keyup.enter)="applyCurrentCountEdit()"
          />
        </mat-form-field>
        <div class="count-edit-actions">
          <button mat-flat-button color="primary" type="button" (click)="applyCurrentCountEdit()">
            Сохранить
          </button>
          <button mat-button type="button" (click)="cancelCountItemEdit()">Отмена</button>
        </div>
      </div>
    </section>
  </mat-card>

  <mat-card
    *ngIf="!isMobileLayout && currentProduct && productBalances.length && (!isStocktakingDocMode || mode !== 'COUNT')"
    class="balances-card"
  >
    <h3>{{ mode === 'INFO' ? 'Где лежит и остатки' : 'Остатки' }}</h3>
    <div class="balance-list">
      <div class="balance-row" *ngFor="let row of productBalances">
        <div class="balance-name">{{ getBalanceLabel(row) }}</div>
        <div class="balance-qty">{{ row.qty }}</div>
      </div>
    </div>
  </mat-card>

  <mat-card *ngIf="isMobileLayout && !isReadOnlyStocktakingDoc" class="mobile-tabs-card">
    <mat-tab-group class="mobile-tabs" animationDuration="0ms">
      <mat-tab label="Текущий товар">
        <div class="mobile-tab-panel">
          <section class="product-hero" *ngIf="currentProduct || pendingProduct; else emptyCurrentProductState">
            <div class="product-hero__media">
              <img
                *ngIf="currentProductImageUrl; else currentProductFallbackImage"
                [src]="currentProductImageUrl"
                [alt]="currentProductDisplayMeta || currentProductDisplayName || 'Товар'"
              />
              <ng-template #currentProductFallbackImage>
                <div class="product-hero__placeholder">
                  <mat-icon>inventory_2</mat-icon>
                </div>
              </ng-template>
            </div>

            <div class="product-hero__copy">
              <div class="product-hero__eyebrow">
                {{ mode === 'INFO' ? 'Информация о товаре' : (pendingProduct ? 'Готов к обработке' : 'Текущий товар') }}
              </div>
              <div class="product-hero__meta">{{ currentProductDisplayMeta }}</div>
              <div class="product-hero__title">{{ currentProductDisplayName || 'Без названия' }}</div>
              <div class="product-facts" *ngIf="currentProduct">
                <div class="product-fact" *ngIf="!isStocktakingDocMode || mode !== 'COUNT'">
                  <span class="product-fact__label">Закупка</span>
                  <strong class="product-fact__value">{{ currentProductPurchasePrice | number:'1.0-2' }}</strong>
                </div>
                <div class="product-fact" *ngIf="!isStocktakingDocMode || mode !== 'COUNT'">
                  <span class="product-fact__label">Розница</span>
                  <strong class="product-fact__value">{{ currentProductRetailPrice | number:'1.0-2' }}</strong>
                </div>
                <div class="product-fact" *ngIf="mode === 'INFO'">
                  <span class="product-fact__label">Склад</span>
                  <strong class="product-fact__value">{{ warehouse?.description || 'Не выбран' }}</strong>
                </div>
                <div class="product-fact" *ngIf="mode === 'INFO'">
                  <span class="product-fact__label">Остаток</span>
                  <strong class="product-fact__value">{{ currentProductTotalQty | number:'1.0-2' }}</strong>
                </div>
                <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
                  <span class="product-fact__label">Система на полке</span>
                  <strong class="product-fact__value">{{ currentExpectedShelfQty | number:'1.0-2' }}</strong>
                </div>
                <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
                  <span class="product-fact__label">Отсканировано</span>
                  <strong class="product-fact__value">{{ currentScannedQty | number:'1.0-2' }}</strong>
                </div>
                <div class="product-fact" *ngIf="mode === 'COUNT' && !isStocktakingDocMode">
                  <span class="product-fact__label">Разница</span>
                  <strong class="product-fact__value">{{ currentCountDeltaLabel }}</strong>
                </div>
              </div>
            </div>
          </section>

          <section
            class="count-focus-card"
            *ngIf="isStocktakingDocMode && mode === 'COUNT' && currentProduct"
          >
            <div class="count-focus-header">
              <div class="tab-section__title">Факт по текущему товару</div>
              <div class="count-focus-meta">Полка {{ currentCell?.code || 'не выбрана' }}</div>
            </div>

            <div class="count-focus-stats">
              <div class="count-focus-stat">
                <span>Система</span>
                <strong>{{ currentExpectedShelfQty | number:'1.0-2' }}</strong>
              </div>
              <div class="count-focus-stat">
                <span>Факт</span>
                <strong>{{ currentScannedQty | number:'1.0-2' }}</strong>
              </div>
              <div class="count-focus-stat">
                <span>Разница</span>
                <strong>{{ currentCountDeltaLabel }}</strong>
              </div>
            </div>

            <div class="count-focus-actions" *ngIf="(currentCountSessionItem || canAlignCurrentCountToSystem) && !isCurrentCountEditing">
              <button mat-stroked-button type="button" (click)="adjustCurrentCount(-1)">-1</button>
              <button mat-stroked-button type="button" (click)="adjustCurrentCount(1)">+1</button>
              <button
                mat-stroked-button
                type="button"
                *ngIf="canAlignCurrentCountToSystem"
                (click)="alignCurrentCountToSystem()"
              >
                Как в системе
              </button>
              <button mat-button type="button" (click)="startCurrentCountEdit()">Изменить</button>
            </div>

            <div class="count-edit count-edit--current" *ngIf="isCurrentCountEditing">
              <mat-form-field>
                <mat-label>Фактическое количество</mat-label>
                <input
                  #countQtyInput
                  matInput
                  type="number"
                  step="0.01"
                  [formControl]="countQtyControl"
                  (keyup.enter)="applyCurrentCountEdit()"
                />
              </mat-form-field>
              <div class="count-edit-actions">
                <button mat-flat-button color="primary" type="button" (click)="applyCurrentCountEdit()">
                  Сохранить
                </button>
                <button mat-button type="button" (click)="cancelCountItemEdit()">Отмена</button>
              </div>
            </div>
          </section>

          <section
            class="secondary-actions secondary-actions--compact current-tab-actions"
            *ngIf="(mode !== 'COUNT' && warehouse?.id) || currentProduct || (mode !== 'INFO' && (currentCell || (mode !== 'COUNT' && activeQtyOverride > 1)))"
          >
            <button
              *ngIf="warehouse?.id && (mode !== 'COUNT' || isStocktakingDocMode)"
              mat-stroked-button
              class="quick-action quick-action--touch quick-action--icon-only"
              type="button"
              (click)="openManualProductSearch($event)"
              aria-label="Найти товар"
              title="Найти товар"
            >
              <mat-icon>search</mat-icon>
            </button>
            <button
              mat-stroked-button
              class="quick-action quick-action--touch quick-action--icon-only"
              type="button"
              (click)="onProductLabelButtonClick($event)"
              (contextmenu)="onProductLabelButtonContextMenu($event)"
              (touchstart)="onProductLabelButtonTouchStart()"
              (touchend)="onProductLabelButtonTouchEnd()"
              (touchcancel)="onProductLabelButtonTouchEnd()"
              [disabled]="!currentProduct"
              aria-label="Этикетка товара"
              title="Этикетка товара"
            >
              <mat-icon>sell</mat-icon>
            </button>
            <button
              *ngIf="mode !== 'INFO'"
              mat-stroked-button
              class="quick-action quick-action--touch quick-action--icon-only"
              type="button"
              (click)="onCellLabelButtonClick($event)"
              (contextmenu)="onCellLabelButtonContextMenu($event)"
              (touchstart)="onCellLabelButtonTouchStart()"
              (touchend)="onCellLabelButtonTouchEnd()"
              (touchcancel)="onCellLabelButtonTouchEnd()"
              [disabled]="!currentCell"
              aria-label="Этикетка ячейки"
              title="Этикетка ячейки"
            >
              <mat-icon>qr_code_2</mat-icon>
            </button>
            <button
              *ngIf="mode !== 'COUNT' && (currentCell || activeQtyOverride > 1)"
              mat-stroked-button
              class="quick-action quick-action--touch"
              [class.quick-action--icon-only]="activeQtyOverride <= 1"
              [class.quick-action--active]="activeQtyOverride > 1"
              type="button"
              (click)="toggleQtyOverridePanel()"
              [attr.aria-label]="activeQtyOverride > 1 ? ('Количество: ' + activeQtyOverride) : 'Количество'"
              [attr.title]="activeQtyOverride > 1 ? ('Количество: ' + activeQtyOverride) : 'Количество'"
            >
              <mat-icon>tune</mat-icon>
              <span *ngIf="activeQtyOverride > 1" class="quick-action__value">
                {{ activeQtyOverride | number:'1.0-2' }} шт.
              </span>
            </button>
          </section>

          <section
            class="count-session-summary"
            *ngIf="mode === 'COUNT' && canUseAdhocCount"
          >
            <div class="count-session-summary__header">
              <div class="tab-section__title">{{ isStocktakingDocMode ? 'Сдача полки' : 'Переучет полки' }}</div>
              <div class="count-session-summary__title">{{ currentCell?.code || 'Полка не выбрана' }}</div>
              <div class="count-session-summary__subtitle">{{ countSessionSummaryText }}</div>
            </div>

            <div class="count-session-summary__stats" *ngIf="currentCell">
              <div class="count-session-summary__stat">
                <span>Позиции</span>
                <strong>{{ countSessionItems.length }}</strong>
              </div>
              <div class="count-session-summary__stat">
                <span>Всего</span>
                <strong>{{ countSessionTotalQty | number:'1.0-2' }}</strong>
              </div>
            </div>

            <div class="count-session-summary__hint" *ngIf="countSessionItems.length && currentProduct">
              Количество по открытому товару меняется в блоке выше.
            </div>

            <div class="count-actions" *ngIf="!isReadOnlyStocktakingDoc">
              <button
                mat-flat-button
                color="primary"
                type="button"
                [disabled]="!canFinishCountSession"
                (click)="finishCountSession()"
              >
                {{ countSessionItems.length ? 'Завершить полку' : 'Сохранить пустую полку' }}
              </button>
              <button
                mat-button
                type="button"
                [disabled]="loading || !currentCell"
                (click)="discardCountSession()"
              >
                Сбросить
              </button>
            </div>
          </section>

          <div *ngIf="showQtyOverride && mode !== 'COUNT' && mode !== 'INFO'" class="qty-panel">
            <div class="qty-inline-row">
              <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(-2)">-2</button>
              <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(-1)">-1</button>
              <label class="qty-inline-field" aria-label="Количество">
                <input
                  class="qty-inline-input"
                  type="number"
                  step="0.01"
                  [formControl]="qtyControl"
                  placeholder="Кол-во"
                  (keyup.enter)="applyCustomQtyOverride()"
                />
              </label>
              <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(1)">+1</button>
              <button mat-stroked-button type="button" class="qty-step-button" (click)="incrementQtyDraft(2)">+2</button>
            </div>
            <div class="qty-apply-row">
              <button mat-flat-button color="primary" type="button" class="qty-apply-button" (click)="applyCustomQtyOverride()">
                Применить
              </button>
            </div>
          </div>

          <section
            class="tab-section"
            *ngIf="currentProduct && productBalances.length && (!isStocktakingDocMode || mode !== 'COUNT')"
          >
            <div class="tab-section__title">{{ mode === 'INFO' ? 'Где лежит и остатки' : 'Остатки по товару' }}</div>
            <div class="summary-row summary-row--inline" *ngIf="mode === 'INFO'">
              <span>Текущий остаток</span>
              <strong>{{ currentProductTotalQty | number:'1.0-2' }}</strong>
            </div>
            <div class="balance-list">
              <div class="balance-row" *ngFor="let row of productBalances">
                <div class="balance-name">{{ getBalanceLabel(row) }}</div>
                <div class="balance-qty">{{ row.qty }}</div>
              </div>
            </div>
          </section>

          <ng-template #emptyCurrentProductState>
            <div class="empty-state">
              {{ mode === 'INFO'
                ? 'Сканируйте товар, чтобы посмотреть фото, цены, остатки и размещение по складу.'
                : 'Сканируйте товар, и здесь появятся фото, название, подсказки и быстрые действия.' }}
            </div>
          </ng-template>
        </div>
      </mat-tab>

      <mat-tab label="История">
        <div class="mobile-tab-panel">
          <section class="tab-section" *ngIf="scanSeries">
            <div class="tab-section__title">Последнее сканирование</div>
            <div class="series-banner series-banner--compact">
              <div class="series-kicker">
                {{ scanSeries.mode === 'COUNT'
                  ? 'Переучет'
                  : scanSeries.mode === 'PLACE'
                    ? 'Размещение'
                    : scanSeries.mode === 'PICK'
                      ? 'Снятие'
                      : 'Инфо' }}
              </div>
              <div class="series-main series-main--compact">
                {{ scanSeries.cellCode !== '-' ? ('Полка ' + scanSeries.cellCode) : 'Без полки' }}
              </div>
              <div class="series-sub">
                {{ scanSeries.qty | number:'1.0-2' }} шт.
              </div>
            </div>
          </section>

          <section class="tab-section" *ngIf="recentActionFeed.length">
            <div class="tab-section__title">Лента событий</div>
            <div class="recent-list">
              <div class="recent-row" *ngFor="let action of recentActionFeed; trackBy: trackByAction">
                <div class="recent-main">
                  <div class="recent-message recent-message--primary">{{ action.message }}</div>
                </div>
                <div class="recent-meta" [class.error]="!action.success">
                  {{ action.qty | number:'1.0-2' }} шт. · {{ action.createdAt | date:'HH:mm' }}
                </div>
              </div>
            </div>
          </section>

          <div class="empty-state" *ngIf="!scanSeries && !recentActionFeed.length">
            История появится после первых сканирований.
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Настройки">
        <div class="mobile-tab-panel">
          <section class="tab-section">
            <div class="tab-section__title">Склад</div>
            <div *ngIf="!isStocktakingDocMode; else stocktakingWarehouseInfo" class="warehouse-panel warehouse-panel--inline">
              <app-warehouse-selector [control]="warehouseControl"></app-warehouse-selector>
            </div>
            <ng-template #stocktakingWarehouseInfo>
              <div class="summary-row">
                <span>Склад</span>
                <strong>{{ stocktakingDoc?.warehouse?.description || warehouse?.description || 'Не выбран' }}</strong>
              </div>
            </ng-template>
          </section>

          <section class="tab-section">
            <div class="tab-section__title">Текущий режим</div>
            <div class="summary-row">
              <span>Режим</span>
              <strong>{{ modeTitle }}</strong>
            </div>
            <div class="summary-row">
              <span>Полка</span>
              <strong>{{ currentCell?.code || 'Не выбрана' }}</strong>
            </div>
            <div class="summary-row" *ngIf="isStocktakingDocMode">
              <span>Статус</span>
              <strong>{{ stocktakingStatusLabel }}</strong>
            </div>
          </section>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card>

  <div class="capture-dock" *ngIf="isMobileLayout" [class.capture-dock--solo]="isStocktakingDocMode">
    <ng-container [ngTemplateOutlet]="captureZoneTemplate"></ng-container>
  </div>

  <div class="mode-dock" *ngIf="!isStocktakingDocMode && isMobileLayout">
    <mat-button-toggle-group class="mode-switch mode-switch--dock" [attr.data-mode]="mode" [formControl]="modeControl">
      <mat-button-toggle value="PLACE">Разместить</mat-button-toggle>
      <mat-button-toggle value="PICK">Снять</mat-button-toggle>
      <mat-button-toggle value="INFO">Инфо</mat-button-toggle>
      <mat-button-toggle value="COUNT" *ngIf="canUseAdhocCount">Переучет</mat-button-toggle>
    </mat-button-toggle-group>
    <a
      mat-stroked-button
      routerLink="/docs/moving/scan"
      class="moving-tsd-entry moving-tsd-entry--dock"
      aria-label="Создать передвижение"
      title="Создать передвижение"
    >
      <mat-icon>swap_horiz</mat-icon>
      <span>Передв.</span>
    </a>
  </div>

  <div class="sheet-backdrop" *ngIf="pendingCellSwitch || pendingUnknownBarcode"></div>

  <section *ngIf="pendingCellSwitch" class="scanner-sheet">
    <div class="sheet-title">Текущая полка не завершена</div>
    <div class="sheet-description">
      Полка {{ currentCell?.code }} еще в переучете. Перед переходом на {{ pendingCellSwitch.code }}
      завершите или сбросьте текущую сессию.
    </div>
    <div class="sheet-actions">
      <button mat-flat-button color="primary" type="button" (click)="finishCountSession(true)">
        Завершить и перейти
      </button>
      <button mat-stroked-button type="button" (click)="discardCountSession(true)">
        Сбросить и перейти
      </button>
      <button mat-button type="button" (click)="cancelPendingCellSwitch()">Остаться</button>
    </div>
  </section>

  <section *ngIf="pendingUnknownBarcode && candidates.length" class="scanner-sheet">
    <div class="sheet-title">Выберите товар</div>
    <div class="sheet-description">
      Код {{ pendingUnknownBarcode }} найден у нескольких товаров.
    </div>
    <div class="sheet-list">
      <button
        mat-stroked-button
        class="sheet-item"
        type="button"
        *ngFor="let item of candidates; trackBy: trackByCandidate"
        [disabled]="loading"
        (click)="pickCandidate(item)"
      >
        <span>{{ item.brand.description }} {{ item.article }}</span>
        <small>{{ item.description }}</small>
        <small *ngIf="item.cellHints.length">Полки: {{ item.cellHints.join(', ') }}</small>
      </button>
    </div>
    <div class="sheet-actions">
      <button mat-button type="button" [disabled]="loading" (click)="closeResolutionSheet()">Закрыть</button>
    </div>
  </section>

  <section *ngIf="pendingUnknownBarcode && tecdocCandidates.length" class="scanner-sheet">
    <div class="sheet-title">Выберите товар TecDoc</div>
    <div class="sheet-description">
      Для кода {{ pendingUnknownBarcode }} найдено несколько карточек. После выбора товар будет создан
      или привязан к существующей карточке.
    </div>
    <mat-progress-bar *ngIf="tecdocCandidateLoading" mode="indeterminate"></mat-progress-bar>
    <div class="sheet-error" *ngIf="tecdocCandidateError" role="alert">
      {{ tecdocCandidateError }}
    </div>
    <div class="sheet-list">
      <button
        mat-stroked-button
        class="sheet-item"
        type="button"
        *ngFor="let item of tecdocCandidates"
        [disabled]="tecdocCandidateLoading"
        (click)="pickTecDocCandidate(item)"
      >
        <span>{{ item.brandName }} {{ item.articleNumber }}</span>
        <small>{{ item.genericArticleName || 'Без названия' }}</small>
        <small *ngIf="item.gtins.length">GTIN: {{ item.gtins.join(', ') }}</small>
      </button>
    </div>
    <div class="sheet-actions">
      <button
        mat-button
        type="button"
        [disabled]="tecdocCandidateLoading"
        (click)="closeResolutionSheet()"
      >
        Закрыть
      </button>
    </div>
  </section>

  <section
    *ngIf="manualProductSearchOpen || (pendingUnknownBarcode && !candidates.length && !tecdocCandidates.length)"
    class="scanner-sheet"
  >
    <ng-container *ngIf="manualProductSearchOpen">
      <div class="sheet-title">Найти товар</div>
      <div class="sheet-description" *ngIf="mode === 'INFO'">
        Найдите товар по артикулу, бренду или названию. После выбора откроется карточка товара.
      </div>
      <div class="sheet-description" *ngIf="mode === 'COUNT'">
        Найдите товар по артикулу, бренду или названию. После выбора можно напечатать наклейку и сразу отметить товар в документе.
      </div>
      <div class="sheet-description" *ngIf="mode !== 'INFO' && mode !== 'COUNT'">
        Найдите товар по артикулу, бренду или названию. После выбора можно напечатать наклейку и разместить товар.
      </div>
    </ng-container>
    <ng-container *ngIf="!manualProductSearchOpen">
    <div class="sheet-title">Код не найден</div>
    <div class="sheet-description">
      Найдите товар, к которому нужно привязать код {{ pendingUnknownBarcode }}.
    </div>
    </ng-container>
    <div class="sheet-error" *ngIf="tecdocCandidateError" role="alert">
      {{ tecdocCandidateError }}
    </div>
    <div class="manual-panel compact">
      <mat-form-field>
        <mat-label>Артикул, бренд или описание</mat-label>
        <input
          #unknownSearchInput
          matInput
          [formControl]="unknownSearchControl"
          autocomplete="off"
          (keyup.enter)="searchUnknownProducts()"
        />
      </mat-form-field>
      <div class="manual-actions">
        <button mat-flat-button color="primary" type="button" [disabled]="loading" (click)="searchUnknownProducts()">
          Найти
        </button>
        <button mat-button type="button" [disabled]="loading" (click)="closeResolutionSheet()">Закрыть</button>
      </div>
    </div>
    <div class="sheet-list" *ngIf="searchResults.length">
      <button
        mat-stroked-button
        class="sheet-item sheet-item--product"
        type="button"
        *ngFor="let item of searchResults; trackBy: trackByProduct"
        [disabled]="loading"
        (click)="selectSearchResult(item)"
      >
        <div class="sheet-item__inner">
          <div class="sheet-item__media">
            <img
              *ngIf="getSearchProductImageUrl(item); else searchProductFallbackImage"
              [src]="getSearchProductImageUrl(item)!"
              [alt]="getSearchProductBrand(item) + ' ' + getSearchProductArticle(item)"
            />
            <ng-template #searchProductFallbackImage>
              <div class="sheet-item__placeholder">
                <mat-icon>inventory_2</mat-icon>
              </div>
            </ng-template>
          </div>
          <div class="sheet-item__content">
            <div class="sheet-item__line">
              <span class="sheet-item__article">{{ getSearchProductArticle(item) }}</span>
              <span class="sheet-item__brand">{{ getSearchProductBrand(item) }}</span>
            </div>
            <div class="sheet-item__title">{{ getSearchProductName(item) }}</div>
          </div>
        </div>
      </button>
    </div>
  </section>
</div>
